export var AddToHistory;
(function (AddToHistory) {
    AddToHistory[AddToHistory["NONE"] = 0] = "NONE";
    AddToHistory[AddToHistory["LOCAL_ONLY"] = 1] = "LOCAL_ONLY";
    AddToHistory[AddToHistory["GLOBAL_ONLY"] = 2] = "GLOBAL_ONLY";
    AddToHistory[AddToHistory["ALL"] = 3] = "ALL";
})(AddToHistory || (AddToHistory = {}));
export var SHUFFLE_KEY = "player_shuffle";
export var AUTOREPLAY_KEY = "player_autoreplay";
export var HQ_KEY = 'hq';
export var PlayerState;
(function (PlayerState) {
    PlayerState[PlayerState["None"] = 0] = "None";
    PlayerState[PlayerState["Error"] = 1] = "Error";
    PlayerState[PlayerState["Paused"] = 2] = "Paused";
    PlayerState[PlayerState["Loading"] = 3] = "Loading";
    PlayerState[PlayerState["Buffering"] = 4] = "Buffering";
    PlayerState[PlayerState["Playing"] = 5] = "Playing";
})(PlayerState || (PlayerState = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/player/types.js
// module id = 78
// module chunks = 0